export const getNMaxAdjustments = () => [

    // Common
    { name: 'NMaxAdjYield', text: 'Yield' },
    { name: 'NMaxAdjMilling', text: 'Milling' },

    // England
    { name: 'NMaxAdjShallowSoil', text: 'Shallow soil' },
    { name: 'NMaxAdjGrassCuts', text: 'Grass cuts' },
    { name: 'NMaxAdjGrassDehydration', text: 'Grass dehydration' },
    { name: 'NMaxAdjStrawMulch', text: 'Straw mulch' },
    { name: 'NMaxAdjPaperWaste', text: 'Paper waste' },

    // Scotland
    { name: 'NMaxAdjYieldOver4Tons', text: 'Yield over 4 tons' },
    { name: 'NMaxAdjRainfall', text: 'Winter rain' },
    { name: 'NMaxAdjHighNDistilling', text: 'High N distilling' },

]
